import React from "react";
import { useNavigate } from "react-router-dom";
import { isLlmsTxtJobComplete, isLlmsTxtJobFailed } from "../../../services/llmsTxtApi";

export default function LlmsTxtHeader({ status, statusLabel }) {
	const navigate = useNavigate();
	const isCompleted = isLlmsTxtJobComplete(status);
	const isFailed = isLlmsTxtJobFailed(status);
	const isProcessing = !isCompleted && !isFailed;

	let badgeClass = "llms-txt__status-badge";
	if (isCompleted) badgeClass += " llms-txt__status-badge--ready";
	else if (isFailed) badgeClass += " llms-txt__status-badge--failed";
	else if (isProcessing) badgeClass += " llms-txt__status-badge--processing";

	return (
		<div className="llms-txt__header">
			<div className="llms-txt__header-left">
				<button
					type="button"
					className="llms-txt__back"
					onClick={() => navigate("/aivisibility/llms-txt")}
				>
					<i className="fas fa-arrow-left me-2" />
					Back
				</button>
			</div>
			{statusLabel && (
				<span className={badgeClass}>
					{isCompleted && <i className="fas fa-check-circle me-1" />}
					{isFailed && <i className="fas fa-times-circle me-1" />}
					{isProcessing && <i className="fas fa-spinner fa-spin me-1" />}
					{statusLabel}
				</span>
			)}
		</div>
	);
}
